import {ObjectUtil} from '../../util/object-util';

export class OfferReadByUser {
  userId: string = null;
  proposalId: string = null;
  offerId: string = null;
  readAt: Date = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }
}
